export default __webpack_public_path__ + "static/media/eBeaconsoftsLogo.3f4884f9.jpg";